import { call, put, takeLatest } from 'redux-saga/effects';
import * as apollo from 'apollo/billing.query';
import { UPDATE_USER_INFO_SUCCESS, GET_USER_INFO } from 'containers/App/constants';
import * as types from './types';

function* createSetupIntent() {
    try {
        const result = yield call(apollo.createSetupIntent);
        const response = result?.createSetupIntent?.clientSecret || '';
        yield put({ type: types.CREATE_SETUP_INTENT_SUCCESS, payload: response });
      } catch (err) {
        yield put ({ type: types.CREATE_SETUP_INTENT_FAIL });
      }
  }

function* attachPaymentMethod(action) {
  const { payload } = action;
  try {
    const response = yield call(apollo.attachPaymentMethod, payload);
    if (!response.errors) {
      yield put({ type: UPDATE_USER_INFO_SUCCESS, payload: response.data.attachPaymentMethod.login });
      yield put({ type: types.GET_BILLING_INFO });
      yield put({ type: types.ATTACH_PAYMENT_METHOD_SUCCESS });
    } else {
      yield put({ type: types.ATTACH_PAYMENT_METHOD_FAIL, payload: response.errors });
    }
  } catch (error) {
    yield put({ type: types.ATTACH_PAYMENT_METHOD_FAIL });
  }
}

function* getBillingInfo() {
  try {
    const response = yield call(apollo.fetchBillingInfo);
    if (!response.errors) {
      yield put({ type: types.GET_BILLING_INFO_SUCCESS, payload: response.data.billingInfo });
    } else {
      yield put({ type: types.GET_BILLING_INFO_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.GET_BILLING_INFO_FAIL });
  }
}

function* getInvoicePreviews() {
  try {
    const response = yield call(apollo.fetchInvoicePreviews);
    if (!response.errors && response.data.invoicePreviews) {
      yield put({ type: types.GET_INVOICE_PREVIEWS_SUCCESS, payload: response.data.invoicePreviews });
    } else {
      yield put({ type: types.GET_INVOICE_PREVIEWS_FAIL });
    }
  } catch (err) {
    yield put({ type: types.GET_INVOICE_PREVIEWS_FAIL, err });
  }
};

function* addPromoOrReferral(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.addPromoOrReferral, payload);
    if (!response.errors) {
      yield put({ type: types.ADD_PROMO_OR_REFERRAL_SUCCESS, payload: response.data.addPromoOrReferral });
      yield put({
        type: UPDATE_USER_INFO_SUCCESS,
        payload: response.data.addPromoOrReferral.login,
      });
      // Re-fetch billing info to update the plans with discounts.
      const billingResponse = yield call(apollo.fetchBillingInfo);
      if (!response.errors) {
        yield put({
          type: types.GET_BILLING_INFO_SUCCESS,
          payload: billingResponse.data.billingInfo,
        });
      }
    } else {
      yield put({ type: types.ADD_PROMO_OR_REFERRAL_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.ADD_PROMO_OR_REFERRAL_FAIL, payload: err });
  }
}

function* trial() {
  try {
    const response = yield call(apollo.trial);
    if (!response.errors) {
      yield put({ type: types.TRIAL_SUCCESS });
      yield put({ type: GET_USER_INFO });
    } else {
      yield put({ type: types.TRIAL_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.TRIAL_FAIL, payload: err });
  }
}

function* cancelTrial() {
  try {
    const response = yield call(apollo.cancelTrial);
    if (!response.errors) {
      yield put({ type: GET_USER_INFO });
    }
  } catch (err) {
    yield put({ type: types.TRIAL_FAIL, payload: err });
  }
}

function* setPauseSubscription(action) {
  try {
    const { payload } = action;
    const result = yield call(apollo.setPauseSubscription, payload);
    yield put({ type: types.SET_PAUSE_SUBSCRIPTION_SUCCESS, payload: result });
    yield put({
      type: UPDATE_USER_INFO_SUCCESS,
      payload: result.data.login,
    });
  } catch (error) {
    yield put ({ type: types.SET_PAUSE_SUBSCRIPTION_FAIL });
  }
}

function* subscribe(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.subscribe, payload);
    if (!response.errors) {
      yield put({ type: types.SUBSCRIBE_SUCCESS, payload: response.data.subscribe.billingAndSubscriptionInfo });
      yield put({ type: GET_USER_INFO });
    } else {
      yield put({ type: types.SUBSCRIBE_FAIL, payload: response.errors });
    }
  } catch (error) {
    yield put({ type: types.SUBSCRIBE_FAIL });
  }
}

function* pauseSubscription() {
  try {
    const response = yield call(apollo.pauseSubscription);
    if (!response.errors) {
      yield put({ type: types.PAUSE_SUBSCRIPTION_SUCCESS, payload: response.data.pauseSubscription });
      yield put({ type: GET_USER_INFO });
    } else {
      yield put({ type: types.PAUSE_SUBSCRIPTION_FAIL, payload: response.errors });
    }
  } catch (error) {
    yield put({ type: types.PAUSE_SUBSCRIPTION_FAIL });
  }
}

function* renewSubscription() {
  try {
    const response = yield call(apollo.renewSubscription);
    if (!response.errors) {
      yield put({ type: types.RENEW_SUBSCRIPTION_SUCCESS, payload: response.data.renewSubscription });
      yield put({ type: GET_USER_INFO });
    } else {
      yield put({ type: types.RENEW_SUBSCRIPTION_FAIL, payload: response.errors });
    }
  } catch (error) {
    yield put({ type: types.RENEW_SUBSCRIPTION_FAIL });
  }
}

function* unsubscribe() {
  try {
    const result = yield call(apollo.unsubscribe);
    yield put({ type: types.UNSUBSCRIBE_SUCCESS, payload: result.data.unsubscribe.billingAndSubscriptionInfo });
    yield put({ type: GET_USER_INFO });
    yield put({ type: types.GET_BILLING_INFO });
  } catch (error) {
    yield put ({ type: types.UNSUBSCRIBE_FAIL });
  }
}

function* updateCustomerAddress(action) {
  const { payload } = action;

  try {
    const response = yield call(apollo.updateCustomerAddress, payload);
    if (!response.errors) {
      yield put({ type: types.UPDATE_CUSTOMER_ADDRESS_SUCCESS, payload: response });
    } else {
      yield put({ type: types.UPDATE_CUSTOMER_ADDRESS_FAIL, payload: response.errors });
    }
  } catch (error) {
    yield put({ type: types.UPDATE_CUSTOMER_ADDRESS_FAIL });
  }
}

export default function* watchList() {
  yield takeLatest(types.CREATE_SETUP_INTENT, createSetupIntent);
  yield takeLatest(types.ATTACH_PAYMENT_METHOD, attachPaymentMethod);
  yield takeLatest(types.GET_BILLING_INFO, getBillingInfo);
  yield takeLatest(types.GET_INVOICE_PREVIEWS, getInvoicePreviews);
  yield takeLatest(types.ADD_PROMO_OR_REFERRAL, addPromoOrReferral);
  yield takeLatest(types.SET_PAUSE_SUBSCRIPTION, setPauseSubscription);
  yield takeLatest(types.SUBSCRIBE, subscribe);
  yield takeLatest(types.PAUSE_SUBSCRIPTION, pauseSubscription);
  yield takeLatest(types.RENEW_SUBSCRIPTION, renewSubscription);
  yield takeLatest(types.TRIAL, trial);
  yield takeLatest(types.CANCEL_TRIAL, cancelTrial);
  yield takeLatest(types.UNSUBSCRIBE, unsubscribe);
  yield takeLatest(types.UPDATE_CUSTOMER_ADDRESS, updateCustomerAddress);
}
